import { Box } from "@mui/joy";
import TextOnRibbon from "./TextOnRibbon";
import AttrsForText from "./AttrsForText";
import { useContext, useEffect, useState } from "react";
import { ContextFromSelections } from "./Context";
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';




export default function AddTextandAttr() {

    

    
    const [selectedData,setSelectedData] = useContext(ContextFromSelections)

    const [addTextcheck,setaddTextcheck] = useState(selectedData.addText)

    const [addBorderLines,setaddBorderLines] = useState(selectedData.ribbonBorderAdd)

    const handleChangeForAddingBorder = () => {
      setaddBorderLines(addBorderLines ? false : true)
    }
  
    useEffect(() => {
      setSelectedData((data) => ({...data,ribbonBorderAdd: addBorderLines}))
    },[addBorderLines])

    const handleChangeForAddingText = ()  => { 
        setaddTextcheck(addTextcheck ? false : true)
    }

    useEffect(() => {
      setSelectedData((data) => ({
        ...data,
        addText: addTextcheck,
        ...(addTextcheck ? {} : {
          textOnRibbon: null,
          font: null,
          icon: null,
        }),
      }));

    }, [addTextcheck]);
    

    return(
        <>
        
        <Box
        sx={{
          paddingTop:2,
          paddingBottom: 1,
          margin: "auto",
          display: 'flex',
          flexWrap: "wrap",
          justifyContent: "space-around",
          // border: "2px solid blue",
          // gap: 2,
          '& > div': { p: 1, borderRadius: 'md', display: 'flex', variant: 'outlined' },
        }}
      >
            <FormControlLabel control={<Switch checked={addTextcheck} onChange={handleChangeForAddingText}/>} label="Add Text" />
            <FormControlLabel control={<Switch checked={addBorderLines} onChange={handleChangeForAddingBorder} />} label="Border Lines" />
            
        </Box>
        <Box>
            <TextOnRibbon />
            <AttrsForText/>
        </Box>
      </>
    )
}